module.exports = __webpack_public_path__ + "static/img/pedals-delay.71ad3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-delay.png
// module id = 56mw
// module chunks = 12